/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_DateInputs */

const de_start_date = /** @type {(inputs: Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/** @type {(inputs: Start_DateInputs) => LocalizedString} */
const en_start_date = () => /** @type {LocalizedString} */ ('start_date')

/**

* @param {Start_DateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const start_date = /** @type {((inputs?: Start_DateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_DateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_start_date(inputs)
	return en_start_date(inputs)
});